<template>
  <div class="jiaotongGonggao">
    <div class="head">
      <div class="navLunbo">
        <li
          v-for="(item, index) in NavList"
          :key="index"
          :class="{ active: index == current }"
          @click="change(index)"
        >
          <p>{{ item }}</p>
          <div :class="{ xiahuaxian: index == current }"></div>
        </li>
      </div>
    </div>

    <div class="container2">
      <div class="tableContent">
        <div class="intableContent">
          <div class="tableHead">
            <div class="left">标题</div>
            <div class="mid" :class="{ noborder: isshow }">内容</div>
            <div class="right" v-if="!isshow"></div>
          </div>

          <div class="tableBody" v-for="item in inContentList" :key="item.id">
            <div class="left">
              <div class="inLeft">
                <div class="leftTitle">{{ item.title }}</div>
                <div class="leftTime">{{ item.pubtime | filterTime }}</div>
              </div>
            </div>
            <div class="mid" :class="{ noborder: isshow }">
              <div class="inMid">
                {{ item.content }}
              </div>
            </div>
            <div class="right" v-if="!isshow">
              <div @click="addIntegral(item)">
                <div class="inRight">查看</div>
                <div class="inRight">详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { Swipe, SwipeItem } from "vant";
import { Tabbar, TabbarItem } from "vant";
import { Tab, Tabs } from "vant";
import { Popup } from "vant";
import { Overlay } from "vant";
import { Dialog } from "vant";
Vue.use(Overlay);

Vue.use(Popup);

Vue.use(Tab);
Vue.use(Tabs);

Vue.use(Tabbar);
Vue.use(TabbarItem);

Vue.use(Swipe);
Vue.use(SwipeItem);
import { doRem } from "../utils/setrem";
import qs from "qs";
export default {
  mounted() {
    this.getList();
    document.querySelector("body").setAttribute("style", "overflow:hidden;");
    this.getHeight();
    if (navigator.userAgent.indexOf("AliApp") > -1) {
      this.isshow = true;
    }
  },
  destroyed() {
    document.querySelector("body").setAttribute("style", "overflow:auto; ");
  },
  filters: {
    filterTime: function (value) {
      return (value = value.substring(0, 11));
    },
  },
  data() {
    return {
      NavList: [],
      contentList: [],
      inContentList: [],
      current: 0,
      FabuPopup: false,
      isshow: false,
      loading: false,
      img: "../assets/images/noAddr.png",
    };
  },
  methods: {
    addIntegral(item) {
      // this.$apis.CmsInterface.addIntegral(this.$axios, {
      //   type: 1,
      //   creditDesc: "阅读交通公告",
      // });
      let ua = navigator.userAgent;
      if (ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
        let a = document.createElement("a");
        a.href = item.url;
        a.click();
      } else {
        this.$apis.CmsInterface.addIntegral(this.$axios, {
          type: 1,
          creditDesc: "阅读-交通公告",
        }).finally(() => {
          let a = document.createElement("a");
          a.href = item.url;
          a.click();
        });
      }
      // console.log(item);
    },
    change(index) {
      this.inContentList = [];
      this.current = index;
      this.inContentList = this.contentList[index].list;
      document.querySelector(".tableContent").scrollTop = 0;
    },
    // getScroll(event) {
    //   event.target.scrollTop = 0;
    // },

    getHeight() {
      let a = window.screen.availHeight;

      let b =
        document.querySelector(".tableContent").offsetTop -
        document.documentElement.scrollTop;
      document.querySelector(".tableContent").style.height = a - b + "px";
    },
    getList() {
      let params = qs.stringify({
        metacode: "TRAFFICNOTICE",
      });
      this.$axios
        .post("appapi/cmsInterface/getCmsInfo", params)
        .then((res) => {
          // console.log(res);
          if (res.data.result !== 1) {
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            // console.log(res);
            res.data.data.forEach((item) => {
              this.NavList.push(item.type);
            });
            res.data.data.forEach((item) => {
              this.contentList.push(item);
            });
            this.inContentList = this.contentList[0].list;
          }
        })
        .catch((err) => {
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.head {
  background-color: #ffffff;
  display: flex;
  padding-top: 2.25rem;
  align-items: center;

  .navLunbo {
    width: 100%;
    height: auto;
    padding: 0 7.25rem;
    background-color: #ffffff;
    display: flex;

    overflow-x: auto;

    li {
      font-size: 1.75rem;
      color: #19212a;
      line-height: 2.5rem;
      white-space: nowrap;
      margin-right: 5.75rem;
    }

    .xiahuaxian {
      height: 0.5rem;
      background: #338989;
      border-radius: 0.5rem;
      margin-top: 0.875rem;
    }

    .active {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #338989;
      font-size: 2.125rem;
      font-weight: bold;
    }
  }
}

.container2 {
  padding-top: 3.4375rem;
  background-color: #ffffff;
  background-image: url("../assets/images/bolangbg.png");
  background-repeat: no-repeat;
  background-size: 100% 13rem;
  .tableContent {
    background-color: #ffffff;
    padding: 1.875rem 2rem 25rem 2rem;
    overflow: auto;
    border-radius: 1rem;

    .tableHead {
      display: flex;
      height: 3.625rem;
      border: 1px solid #e3e3e3;
      .left {
        width: 10.5rem;
        text-align: center;
        line-height: 3.625rem;
        color: #555555;
        font-size: 1.75rem;
        font-weight: bold;
        border-right: 1px solid #e3e3e3;
      }
      .mid {
        width: 25.875rem;
        text-align: center;
        line-height: 3.625rem;
        color: #555555;
        font-size: 1.75rem;
        font-weight: bold;
        border-right: 1px solid #e3e3e3;
      }
      .right {
        flex-grow: 1;
      }
    }
    .tableBody {
      display: flex;
      border: 1px solid #e3e3e3;
      border-top: none;

      .left {
        width: 10.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-right: 1px solid #e3e3e3;
        .inLeft {
          .leftTitle {
            color: #19212a;
            font-size: 1.75rem;
            padding: 0 0.5rem 0 1rem;
          }
          .leftTime {
            color: #878787;
            font-size: 1.375rem;
            text-align: center;
            margin-top: 0.5rem;
          }
        }
      }
      .mid {
        width: 25.875rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-right: 1px solid #e3e3e3;
        .inMid {
          color: #555555;
          font-size: 1.75rem;
          padding: 2.125rem 1.375rem 2.25rem 1.125rem;
        }
      }
      .right {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .inRight {
          color: #338989;
          font-size: 1.75rem;
          text-align: center;
        }
      }
    }
  }
}
.noborder {
  border-right: 0 !important;
}
</style>
